import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  useTheme,
} from "@mui/material";
import cancel from "../assets/images/cancel.svg";
import CloseIcon from "@mui/icons-material/Close";

type RejectedPopup = {
  open: boolean;
  onClose: () => void;
  label: string;
  text?: string;
};

const RejectedPopup: React.FC<RejectedPopup> = ({
  open,
  onClose,
  label,
  text,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "visible",
          px: 4,
          pt: 6,
          pb: 3,
          position: "relative",
          boxShadow: 5,
          borderBottom: `6px solid #E8003F`,
          height: 250,
          width: 450,
        },
      }}
    >
      {/* Green Circle Icon */}
      <Box
        sx={{
          position: "absolute",
          top: -60,
          left: "50%",
          transform: "translateX(-50%)",
          width: 125,
          height: 125,
          borderRadius: "50%",
          backgroundColor: "background.default",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "inset 0 0 12px rgba(0, 0, 0, 0.2)",
        }}
      >
        <img
          src={cancel}
          alt="Logo"
          style={{ height: 70, width: 70, objectFit: "contain" }}
        />
      </Box>

      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: -4,
          right: -4,
          backgroundColor: "error.main",
          color: "#fff",
          "&:hover": {
            backgroundColor: "error.dark",
          },
          width: 30,
          height: 30,
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>

      <DialogContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={1}
        >
          <Typography fontSize={38} fontWeight={600} color="#E8003F">
            {label}
          </Typography>
          <Typography fontSize={16} fontWeight={400} color="text.secondary">
            {text}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RejectedPopup;
